import { Grid, Paper, Divider, Chip } from '@mui/material';
import { Link as MuiLink } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { ContactInfoDisplay } from 'app/components/ContactInfoDisplay';
import Logo from 'app/components/Logo';
import { translations } from 'locales/i18n';
import { Company } from 'types/AppTypes';

const fullAddress = company => {
  return (
    <>
      {company.street}
      <br />
      {company.zip} {company.city}
      <br />
      {company.country}
    </>
  );
};

export const CompanyDetailContact = ({
  company,
  mainContactView,
  invoiceView
}: {
  company: Company;
  mainContactView: boolean;
  invoiceView: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Grid component={Paper} square item xs={12} md={3} className="company-detail-page__contact">
      <Grid container justifyContent="center">
        <Logo path="jobmarket/logos" src={company.logo} size="medium" />
      </Grid>
      <Grid container className="company-detail-page__contact__company">
        <ContactInfoDisplay label={t(translations.common.address())}>
          {fullAddress(company)}
        </ContactInfoDisplay>
        {company.phone && (
          <ContactInfoDisplay label={t(translations.common.phone())}>
            {company.phone}
          </ContactInfoDisplay>
        )}
        {company.fax && (
          <ContactInfoDisplay label={t(translations.common.fax())}>
            {company.fax}
          </ContactInfoDisplay>
        )}
        <ContactInfoDisplay label={t(translations.common.email_short())}>
          <MuiLink href={`mailto:${company.email}`} target="_blank">
            {company.email}
          </MuiLink>
        </ContactInfoDisplay>
        <ContactInfoDisplay label={t(translations.common.homepage())}>
          <MuiLink href={company.homepage} target="_blank">
            {company.homepage}
          </MuiLink>
        </ContactInfoDisplay>
      </Grid>
      <Divider />
      {mainContactView ? (
        <>
          <Divider />
          <Grid container className="company-detail-page__contact__section">
            <Grid container className="company-detail-page__contact__section__heading">
              {t(translations.common.contactPerson())}
            </Grid>
            <ContactInfoDisplay label={t(translations.common.name())}>
              {company.mainContact.firstName} {company.mainContact.lastName}
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.email_short())}>
              <MuiLink href={`mailto:${company.mainContact.email}`} target="_blank">
                {company.mainContact.email}
              </MuiLink>
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.phone())}>
              {company.mainContact.phone}
            </ContactInfoDisplay>
          </Grid>
        </>
      ) : undefined}
      {invoiceView ? (
        <>
          <Divider />
          <Grid container className="company-detail-page__contact__company">
            <Grid container className="company-detail-page__contact__section__heading">
              {t(translations.common.invoiceAddress())}
            </Grid>
            <ContactInfoDisplay label={t(translations.common.companyName())}>
              {company.sameInvoiceaddress ? company.name : company.invoiceName}
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.street())}>
              {company.sameInvoiceaddress ? company.street : company.invoiceStreet}
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.zip())}>
              {company.sameInvoiceaddress ? company.zip : company.invoiceZip}
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.city())}>
              {company.sameInvoiceaddress ? company.city : company.invoiceCity}
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.country())}>
              {company.sameInvoiceaddress ? company.country : company.invoiceCountry}
            </ContactInfoDisplay>
            <ContactInfoDisplay label={t(translations.common.invoiceEmail())}>
              {company.invoiceEmail}
            </ContactInfoDisplay>
          </Grid>
        </>
      ) : undefined}
      <Divider />
      <Grid container className="company-detail-page__contact__section">
        <Grid container className="company-detail-page__contact__section__heading">
          {t(translations.common.courses())}
        </Grid>
        <Grid container className="company-detail-page__contact__section__faculties">
          {company.courses.map(c => (
            <Chip
              className="company-detail-page__contact__section__faculties__faculty"
              key={c.id}
              label={c.name}
              variant="outlined"
              component={Paper}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
